import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Paper } from '@mui/material';
import Grid from 'material/components/Grid';

import {
  fetchActionCenter,
  fetchTextActionAlert,
  fetchTextActionAlertRecipients,
} from 'store/actions/campaigns';
import { campaignsSelectors } from 'store/selectors/campaigns';

import {
  Backdrop,
  BreadcrumbsNavigation,
  Container,
  RecipientsMap,
  RecipientsTable,
  TabPanel,
  Tabs,
} from 'common/components';

import { TabsWrapper } from 'globalStyles';
import TextActionAlertOverview from '../components/TextActionAlertOverview';
import TextActionAlertTopCard from '../components/TextActionAlertTopCard';

const StyledPaper = styled(Paper)`
  width: 100%;
  border-bottom: 0;
`;

const ActionAlertTablesWrapper = styled.div`
  margin: 64px 0 82px;
`;

const TextActionAlertDetails = () => {
  const dispatch = useDispatch();
  const { actionAlertUuid, actionCenterUuid, campaignUuid, organizationUuid } = useParams();

  const {
    actionAlertDetails,
    actionAlertRecipients,
    actionCenterDetails,
    isActionAlertFetching,
    isActionAlertRecipientsFetching,
  } = useSelector(state => ({
    actionAlertDetails: campaignsSelectors.getActionAlertDetails(state),
    actionAlertRecipients: campaignsSelectors.getActionAlertRecipients(state),
    actionCenterDetails: campaignsSelectors.getActionCenterDetails(state),
    isActionAlertFetching: campaignsSelectors.isActionAlertFetching(state),
    isActionAlertRecipientsFetching: campaignsSelectors.isActionAlertRecipientsFetching(state),
  }));

  useEffect(() => {
    if (
      Object.keys(actionCenterDetails).length === 0 ||
      actionCenterUuid !== actionCenterDetails.uuid
    ) {
      dispatch(fetchActionCenter(actionCenterUuid));
    }

    dispatch(fetchTextActionAlert(actionAlertUuid));
    dispatch(fetchTextActionAlertRecipients(actionAlertUuid));
  }, []);

  const [tabIndex, setTabIndex] = useState('recipients');

  const { campaign, name } = actionAlertDetails;

  const handleChangeTablesTab = newValue => {
    setTabIndex(newValue);
  };

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/campaigns`,
      name: 'Advocacy',
    },
    {
      link: `/${organizationUuid}/campaigns/${campaignUuid}`,
      name: campaign?.name,
    },
    {
      link: `/${organizationUuid}/campaigns/${campaignUuid}/action-centers/${actionCenterUuid}?tab=0`,
      name: actionCenterDetails?.name,
    },
    {
      link: '',
      name,
    },
  ];

  const textActionAlertTabs = [
    {
      label: 'Recipients',
      value: 'recipients',
    },
  ];

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <TextActionAlertTopCard />
        </Grid>
        <Grid container>
          <TextActionAlertOverview />
        </Grid>
        <TabsWrapper>
          <StyledPaper square variant="outlined">
            <Tabs
              handleSetTab={() => null}
              tabs={[
                {
                  label: 'Contacts',
                  value: 0,
                },
              ]}
              tabIndex={0}
            />
            <TabPanel index={0} value={0}>
              <RecipientsMap alertType="text" />
            </TabPanel>
          </StyledPaper>
        </TabsWrapper>
        <ActionAlertTablesWrapper>
          <StyledPaper square variant="outlined">
            <Tabs
              handleSetTab={handleChangeTablesTab}
              tabs={textActionAlertTabs}
              tabIndex={tabIndex}
            />
          </StyledPaper>
          <TabPanel index={textActionAlertTabs[0].value} value={tabIndex}>
            <RecipientsTable
              isDataFetching={isActionAlertRecipientsFetching}
              isTextRecipients
              recipients={actionAlertRecipients}
            />
          </TabPanel>
        </ActionAlertTablesWrapper>
        <Backdrop isOpen={isActionAlertFetching} />
      </Container>
    </>
  );
};

export default TextActionAlertDetails;
